<template>
  <AppLayout
    :is-initialized="isInitialized"
    :error="error"
  >
    <template
      v-if="isCardDisabled"
      #banner
    >
      <TheCardOff />
    </template>
    <template #header>
      <TheHeader />
    </template>
    <template #navbar>
      <TheNavbar />
    </template>
    <template #main>
      <section class="page__container">
        <RouterView v-slot="{ Component, route }">
          <transition
            :name="route.meta.transition || 'fade'"
            mode="out-in"
          >
            <component :is="Component" />
          </transition>
        </RouterView>
      </section>
    </template>
    <template #footer>
      <TheCall v-if="!isCardDisabled" />
      <TheFooter />
      <AppToast />
      <AppConfirmDialog />
    </template>
  </AppLayout>
</template>

<script>
import App from '@/shared/components/App.vue';
import AppLayout from '@/shared/components/layout/AppLayout.vue';
import TheFooter from '@/projects/people/components/TheFooter/TheFooter.vue';
import TheHeader from '@/projects/people/components/TheHeader/TheHeader.vue';
import TheNavbar from '@/projects/people/components/TheNavbar/TheNavbar.vue';
import TheCardOff from '@/projects/people/components/TheCardOff/TheCardOff.vue';
import TheCall from '@/projects/people/components/TheCall/TheCall.vue';
import AppToast from '@/shared/components/AppToast/AppToast.vue';
import AppConfirmDialog from '@/shared/components/AppConfirmDialog/AppConfirmDialog.vue';
import AppInfoDialog from '@/shared/components/AppInfoDialog/AppInfoDialog.vue';

export default {
  name: 'App',
  components: {
    AppInfoDialog,
    AppLayout,
    AppToast,
    AppConfirmDialog,
    TheFooter,
    TheHeader,
    TheCardOff,
    TheNavbar,
    TheCall,
  },
  extends: App,
};
</script>

<style lang="scss">
@import "@/shared/assets/styles/App.scss";
</style>
